import { useCallback, useEffect } from 'react';
import { usePhrase } from '@/hooks';
import { GENERAL_PHRASES } from '@/consts/phrases/generalPhrases';
import { isArrayWithValues } from '@/utils/fp';

export type metaTagsNamesType =
    | 'description'
    | 'keywords'
    | 'robots'
    | 'copyright'
    | 'language'
    | 'topic'
    | 'summary';

export interface usePageMetaDataProps {
    pageTitlePhraseId?: number;
    pageTitlePhrase?: string;
    metaTags?: { name: metaTagsNamesType; contentPhraseId: number }[];
}

export const usePageMetaData = ({
    pageTitlePhraseId,
    pageTitlePhrase,
    metaTags,
}: usePageMetaDataProps) => {
    const { t } = usePhrase();

    const pageTitle = pageTitlePhrase || (pageTitlePhraseId && t(pageTitlePhraseId)) || null;

    const setTitle = useCallback(() => {
        document.title = pageTitle
            ? `${pageTitle as string} - ${t(GENERAL_PHRASES.PANEL_TITLE, { asString: true })}`
            : t(GENERAL_PHRASES.PANEL_TITLE, { asString: true });
    }, [pageTitle, t]);

    const setMetaTags = useCallback(() => {
        if (metaTags && isArrayWithValues(metaTags)) {
            metaTags.map(({ name, contentPhraseId }) => {
                const metaTag = document.createElement('meta');
                metaTag.name = name;
                metaTag.content = t(contentPhraseId, { asString: true });
                document.head.append(metaTag);
            });
        }
    }, [metaTags, t]);

    useEffect(() => {
        setTitle();
        setMetaTags();
    }, [setMetaTags, setTitle]);
};
